// src/components/GallerySection.jsx
import React, { useEffect, useState } from "react";

const defaultImages = [
  "/images/gallery/1.jpg",
  "/images/gallery/4.jpg",
  "/images/gallery/5.jpg",
  "/images/gallery/6.jpg",
  "/images/gallery/7.jpg",
  "/images/gallery/8.jpg",
   "/images/gallery/48.jpeg",
  "/images/gallery/49.jpeg",
  "/images/gallery/50.jpeg",
  "/images/gallery/9.jpg",

  "/images/gallery/10.jpg",
  "/images/gallery/11.jpg",
  "/images/gallery/12.jpg",
  "/images/gallery/13.jpg",
   "/images/gallery/2.jpg",
  "/images/gallery/14.jpg",
  "/images/gallery/15.jpg",
  "/images/gallery/16.jpg",
  "/images/gallery/19.jpg",
  "/images/gallery/20.jpg",
  "/images/gallery/21.jpg",
  "/images/gallery/22.jpg",
  "/images/gallery/23.jpg",
  "/images/gallery/24.jpg",
  "/images/gallery/25.jpg",
  "/images/gallery/26.jpg",
  "/images/gallery/27.jpg",
  "/images/gallery/28.jpg",
  "/images/gallery/29.jpg",
  "/images/gallery/30.jpg",
  "/images/gallery/31.jpg",
  "/images/gallery/32.jpg",
  "/images/gallery/33.jpg",
  "/images/gallery/34.jpg",
  "/images/gallery/35.jpg",
  "/images/gallery/36.jpg",
  "/images/gallery/37.jpg",
  "/images/gallery/38.jpg",
  "/images/gallery/39.jpg",
  "/images/gallery/40.jpg",
  "/images/gallery/41.jpg",
  "/images/gallery/43.jpeg",
 
 
  "/images/gallery/51.jpeg",
  "/images/gallery/52.jpeg",
  "/images/gallery/55.jpeg",
  "/images/gallery/53.jpeg",
  "/images/gallery/54.jpeg",
 "/images/gallery/45.jpeg",
  "/images/gallery/46.jpeg",
];

export default function GallerySection({ images = defaultImages }) {
  const [idx, setIdx] = useState(null); // null = lightbox closed

  const openAt = (i, e) => {
    e?.preventDefault();
    setIdx(i);
  };
  const close = () => setIdx(null);
  const prev = (e) => {
    e?.stopPropagation();
    setIdx((i) => (i - 1 + images.length) % images.length);
  };
  const next = (e) => {
    e?.stopPropagation();
    setIdx((i) => (i + 1) % images.length);
  };

  useEffect(() => {
    if (idx === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") prev(e);
      if (e.key === "ArrowRight") next(e);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [idx, images.length]);

  return (

<>


    <section
      className="page-title"
      style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
    >
      <div className="auto-container">
        <h1>Gallery </h1>
       
      </div>
    </section>

    <section className="gallery-section">
      <div className="auto-container">
        {/* Title */}
        <div className="faqs-title">
          <h3>Visual Tour<br/>
A Glimpse into the Warmth of Shree Swami Samarth PG</h3>
          <div className="separator"></div>
        </div>

        {/* Bootstrap grid wrapper */}
        <div className="row g-3">
          {images.map((src, i) => {
            // First 4 -> 2 columns on md+; Others -> 3 columns on md+
            const colClass =
              i < 4
                ? "col-12 col-sm-6 col-md-4"
                : "col-12 col-sm-6 col-md-4";
            return (
              <div className={`${colClass} gallery-item`} key={src + i}>
                <a
                  href={src}
                  className="plus-icon lightbox-image"
                  data-fancybox-group="gallery-one"
                  onClick={(e) => openAt(i, e)}
                >
                  <div className="gallery-box">
                    <div className="gallery-img">
                      <img src={src} alt={`Gallery ${i + 1}`} loading="lazy" />
                    </div>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </div>

   
    </section>
</>
  );
}
